import { CssBaseline as MUIBaseLine } from '@mui/material';

/** Sets up a reset.css type baseline. */
export const CssBaseLine = () => {
    return (<MUIBaseLine />);
};